import React, { Component } from "react";
import { Loading } from "./partials/Global/Loading";
import { ProgressScrollButton } from "./partials/Global/ProgressScrollButton";
import { Navigation } from "./partials/Home/Navigation";
import { Slider } from "./partials/Home/Slider";
// import { PopUp } from "./PopUp";

class Home extends Component {
    constructor(props) {
        super(props);
        /*this.state = {
            showNotice: true
        };*/
    }

    /*handleCloseNotice = () => {
        this.setState({ showNotice: false });
    };*/

    render() {
        return (
            <div>
                {/*{this.state.showNotice && <PopUp onClose={this.handleCloseNotice} />}*/}
                <Loading />
                <ProgressScrollButton />
                <Navigation />
                <Slider />
            </div>
        );
    }
}

export default Home;